import State from '../core/State';
import { VisitorData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingVisitorsBySession = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySession.fetching = draft.visitorsBySession.fetching + 1;
  });

export const setVisitorsBySession = (visitorData: VisitorData) =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySession.data = visitorData;
  });

export const finishFetchingVisitorsBySession = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySession.fetching = draft.visitorsBySession.fetching - 1;
  });

export const disposeVisitorsBySession = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySession.data = initialState.visitorsBySession.data;
    draft.visitorsBySession.fetching = initialState.visitorsBySession.fetching;
  });
